import React from 'react';
import type { TooltipProps } from 'ui-components/tooltip/tooltip';
import type { SimpleTooltipProps } from '@placer-ui/components';
import cn from 'classnames';
import styles from './tooltip.module.scss';

const placementConverter: Record<
    NonNullable<TooltipProps['placement']>,
    SimpleTooltipProps['placement']
> = {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    topLeft: 'top',
    topRight: 'top',
    bottomLeft: 'bottom',
    bottomRight: 'bottom',
    leftTop: 'left',
    leftBottom: 'left',
    rightTop: 'right',
    rightBottom: 'right',
};

export const convertPropsToSimpleTooltipProps = (props: TooltipProps): SimpleTooltipProps => {
    const { title, children, placement, useParentContainer, className } = props;

    return {
        title: <div className={cn(className, styles.antdStyleTooltip)}>{title}</div>,
        children: <>{children}</>,
        placement: placement ? placementConverter[placement] : undefined,
        appendToParent: useParentContainer,
    };
};
